import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import { Web3ModalProvider } from './Web/Web3Provider';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { WalletProvider } from '../src/context/WalletContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Web3ModalProvider>
      <WalletProvider>
        <App />
      </WalletProvider>
    </Web3ModalProvider>
  </BrowserRouter>
);

